
  import { underscore } from 'inflected';

  export default {
    props: {
      filterButton: { type: Boolean, default: true },
      header: { type: String, required: true },
      modelName: { type: String, default: 'search' },
      showButton: { type: Boolean, default: true },
      constraints: { type: Object, default () { return {}; } },
      disabled: { type: Boolean, default: false },
      field: { type: String, required: true },
      fieldType: { type: String, default: 'text' },
      i18nAttrs: { type: Object, default () { return {}; } },
      i18nField: { type: String, default: null },
      i18nModel: { type: String, default: null },
      inlineLabel: { type: String, default: null },
      inputAttrs: { type: Object, default () { return {}; } },
      rangeMaxValue: { type: Number, default: 0 },
      rangeMoney: { type: Boolean, required: false },
      required: { type: Boolean, default: false },
      showLabel: { type: Boolean, default: true }
    },
    data () {
      return {
        tooltipContainer: null
      };
    },
    computed: {
      calculatedConstraints () {
        return { ...this.constraints, ...{ min: this.minValue, max: this.maxValue, step: this.calculatedStep } };
      },
      calculatedStep () {
        return this.i18nAttrs.step || this.validations.step || this.constraints.step || 1;
      },
      errorMessage () {
        const errors = this.$store.getters['utils/getFormErrors'];
        if (errors[this.field]) {
          return errors[this.field];
        }
        return errors[[this.modelName, this.field].join('.')] || errors[[underscore(this.modelName), this.field].join('.')];
      },
      i18nScope () {
        return `${this.i18nModel || this.modelName}.${this.i18nField || this.field}`;
      },
      maxValue () {
        if (this.rangeMaxValue > 0) {
          return this.rangeMaxValue;
        }
        const maxes = [this.constraints.max, this.validationFor('less_than_or_equal_to')];
        const lt = this.validationFor('less_than');
        if (lt) {
          maxes.push(lt - this.calculatedStep);
        }
        return Math.min(...maxes.filter(v => v));
      },
      minValue () {
        if (this.inputAttrs.min) {
          return this.inputAttrs.min;
        }
        const values = [this.constraints.min, this.validationFor('greater_than_or_equal_to'), this.validationFor('at_least')].filter(v => !isNaN(v));
        if (values.length) {
          return Math.max(...values);
        }
        return 0;
      },
      placeholder () {
        const key = `${this.i18nScope}.placeholder`;
        return this.$te(key) ? this.$t(key) : null;
      },
      subtitle () {
        const key = `${this.i18nScope}.subtitle`;
        if (this.$te(key)) {
          return this.$t(key);
        }
        return null;
      },
      tooltipOptions (e) {
        const key = `${this.i18nScope}.tooltip`;
        if (this.$te(key)) {
          let opts = { classes: 'fieldsetTooltip', content: this.$t(key), container: this.tooltipContainer, placement: 'top' };
          if (!this.$store.getters['utils/isTablet']) {
            opts.trigger = 'click';
          }
          return opts;
        }
        return null;
      },
      validations () {
        return this.$store.getters['products/getValidations'].filter(v => v.field === this.field).map(v => v.options);
      }
    },
    watch: {
      errorMessage (newVal) {
        if (newVal && !this.$store.getters['utils/getFormErrorScrolled']) {
          this.$store.commit('utils/setFormErrorScrolled', true);
          this.$el.scrollIntoView();
        }
      }
    },
    mounted () {
      this.tooltipContainer = this.getToolTipSpan();
    },
    methods: {
      change () {
        this.$store.dispatch('matomo/trackFilterChange', {name: `Changed filter named: ${this.field}`});
        this.$emit('change');
      },
      getToolTipSpan () {
        return this.$refs['tooltip'];
      },
      validationFor (operation) {
        const validation = this.validations.find(v => v[operation]);
        return validation ? validation[operation] : null;
      }
    }
  };
